<app-header (filterChange)="onCategoryFilterChange($event)" (brandFilterChange)="onBrandFilterChange($event)"
  (openFilterChange)="onOpenFilterChange($event)" (searchFilterChange)="onSearchFilterChange($event)">
</app-header>

<div class="catlog-page">

  <ul class="breadcrumb">

    <li *ngFor="let item of sortedCategoryHierarchy;let i=index">
      <span>{{ item.value }}</span>
      <i  class="ri-arrow-right-s-line"></i>
    </li>
    <span>{{ msnDetails?.msnName }}</span>
  </ul>
  <h1 class="back-heading">
    <i class="ri-arrow-left-line" (click)="onSupplierPage()"></i> ({{supplierId}}) {{ showSupplierName }}
  </h1>

  <section class="mog3_msnsearchtable supplier-detail-table" tabindex="0" infiniteScroll [infiniteScrollDistance]="1"
  [infiniteScrollThrottle]="8" (scrolled)="onScroll()" [infiniteScrollDisabled]="isFullListDisplayed"
  [scrollWindow]="false">
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="TimeAndDate">
        <th mat-header-cell *matHeaderCellDef>
          Time and Date
          <div class="sorting-btn" (click)="toggleSort()">
            <i
              [ngClass]="{
                'ri-sort-desc': sortAscending == true,
                'ri-sort-asc': sortAscending == false
              }"
            ></i>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.createdAt }}
        </td>
      </ng-container>

      <ng-container matColumnDef="CPONo">
        <th mat-header-cell *matHeaderCellDef>CPO No.</th>
        <td mat-cell *matCellDef="let element">
          <span class="link font-500"> {{ element.cpoNo }} </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="ProductName">
        <th mat-header-cell *matHeaderCellDef>Product Name</th>
        <td mat-cell *matCellDef="let element">
          {{ msnDetails?.msnName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="ContactPerson">
        <th mat-header-cell *matHeaderCellDef>Contact Person</th>
        <td mat-cell *matCellDef="let element">
          {{ element.supplierContactName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="TP">
        <th mat-header-cell *matHeaderCellDef>TP</th>
        <td mat-cell *matCellDef="let element">
          {{ element.lastTp }}
        </td>
      </ng-container>

      <ng-container matColumnDef="SP">
        <th mat-header-cell *matHeaderCellDef>SP</th>
        <td mat-cell *matCellDef="let element">{{ element.salesPrice }}</td>
      </ng-container>

      <ng-container matColumnDef="PaymentType">
        <th mat-header-cell *matHeaderCellDef>Payment Type</th>
        <td mat-cell *matCellDef="let element">
          {{ element.paymentType }}
        </td>
      </ng-container>

      <ng-container matColumnDef="MRN">
        <th mat-header-cell *matHeaderCellDef>MRN Days<p style="font-size: 10px;">(SPO Date - MRN Date)</p></th>
        <td mat-cell *matCellDef="let element">
          <span *ngIf="element.mrnDays!=null">{{ element.mrnDays }}</span>
          <span *ngIf="element.mrnDays==null">-</span>
          <span></span>
        </td>
      </ng-container>

      <ng-container matColumnDef="LeadTime">
        <th mat-header-cell *matHeaderCellDef>Lead Time</th>
        <td mat-cell *matCellDef="let element">
          <span *ngIf="element.leadTime==null">-</span>
          <span>{{ element.leadTime }}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="DeliveryType">
        <th mat-header-cell *matHeaderCellDef>Delivery Type</th>
        <td mat-cell *matCellDef="let element">
          <span>{{ element.deliveryType }}</span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayColumns"></tr>
    </table>
  </section>
</div>
